/**
 * Centralized tunables — magic numbers that were previously scattered
 * across DnD, history, layout, and viewport code.  Each constant has
 * a short note explaining what tuning it affects.
 *
 * Keep this file dependency-free so it can be imported from anywhere
 * (touch polyfill, React components, tests).
 */

export const TOUCH_DND = {
  /** Hold time before a touch is promoted to a drag.  Below this,
   *  movement is treated as scroll intent (#2 round-5). */
  longPressMs: 350,
  /** Movement during long-press that cancels promotion. */
  scrollCancelPx: 8,
  /** Floating preview opacity. */
  previewOpacity: 0.7,
} as const;

export const BUCKET_CFG = {
  /** Soft TTL — if the binary's bucket constants change, server-side
   *  ETag triggers refetch immediately, so this is a safety bound. */
  staleMs: 5 * 60 * 1000,
  /** Fallback wall-tier threshold used when bucket-config GET fails. */
  fallbackWallYMinMm: 1200,
  /** Fallback tall-tier height threshold. */
  fallbackTallHeightMm: 1700,
} as const;

export const COLLISION = {
  /** Margin between collidable modules in the same room/composition. */
  marginMm: 50,
} as const;

export const HISTORY_UI = {
  /** How many entries to render at once in the dropdown list (#8 round-7
   *  virtualization).  At scroll edges the next chunk is materialised. */
  windowSize: 100,
  /** Dropdown max-height in CSS px. */
  maxHeightPx: 400,
} as const;
